import { createStore, combineReducers, applyMiddleware } from 'redux'
import ReduxThunk from 'redux-thunk'

import ShoppingCartReducer from './ShoppingCartReducer'
import PlansReducer from './PlansReducer'
import DIDsReducer from './DIDsReducer'
import HostedPbxReducer from './HostedPbxReducer'
import DialingPlansReducer from './DialingPlansReducer'
import EquipmentReducer from './EquipmentReducer'
import OfferContactUsReducer from './OfferContactUsReducer'

const rootReducer = combineReducers({
    ShoppingCartReducer,
    PlansReducer,
    DIDsReducer,
    HostedPbxReducer,
    DialingPlansReducer,
    EquipmentReducer,
    OfferContactUsReducer,
})

export default createStore(rootReducer, applyMiddleware(ReduxThunk));